import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from '../App.tsx';
import './index.css';
import { getBasePath } from '../constants.ts';

// Registro robusto e imediato do Service Worker do PWA para ativação instantânea das APIs nativas
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    let swUrl = '/sw.js';
    try {
      const base = getBasePath();
      if (base && base !== '/') {
        swUrl = base.endsWith('/') ? `${base}sw.js` : `${base}/sw.js`;
      }
    } catch (e) {
      swUrl = '/sw.js';
    }
    
    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        console.log('PWA Service Worker registrado com sucesso no escopo:', registration.scope);
      })
      .catch((error) => {
        console.log('Erro ou bypass de Service Worker em ambiente de desenvolvimento local:', error);
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
